// src/components/Items_From_Cart.jsx
import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PerfectScrollbar from 'react-perfect-scrollbar';
import {
  addToCart,
  removeFromCart,
  clearCart,
  getAvailableUserDetail,
  getAvailableCartItems,
} from '../redux/addCart/cartSlice';
import { getImagePath } from '../constants/defaultValues';
import { savePreInvoiceRequest } from '../redux/pos/posSlice';
import { getCurrentTenant, getCurrentUser } from '../redux/auth/authSlice';
import { useThemeColors } from '../hooks/useThemeColors';
import { toast } from 'react-toastify';
import { FaTrashAlt, FaPlus, FaMinus } from 'react-icons/fa';
import EmptyCart from './common/EmptyCart';

const Items_From_Cart = ({ setShowBucketDetails, darkMode }) => {
  const dispatch = useDispatch();

  // Hook se central colors nikalain
  const {
    contentBg,
    cardBg,
    textColor,
    subTextColor,
    borderColor,
    headerBg,
    isDark,
  } = useThemeColors(darkMode);

  const cartItems = useSelector(getAvailableCartItems);
  const userDetail = useSelector(getAvailableUserDetail);
  const user = useSelector(getCurrentUser);
  const currentTenant = useSelector(getCurrentTenant);
  const [emptyButton, setEmptyButton] = useState(true);

  const totalPrice = cartItems.reduce(
    (sum, item) => sum + item.shopPrice * item.quantity,
    0
  );
  const finalTotal = totalPrice;

  const handlerForPlaceOrder = (e) => {
    e.preventDefault();

    if (!user) {
      toast.error('Please Login First');
      return;
    }

    if (!userDetail?.customerAddress) {
      toast.error('Please select a delivery address!');
      return;
    }

    if (!userDetail?.customerName) {
      toast.error('Please fill your name.');
      return;
    }

    if (!userDetail?.customerMobileNumber) {
      toast.error('Please fill your phone number.');
      return;
    }

    const emptyGuid = '00000000-0000-0000-0000-000000000000';
    const currentDate = new Date().toISOString();

    const onLoad = {
      id: emptyGuid,
      date: currentDate,
      conversionTime: currentDate,
      totalAmount: Number(finalTotal) || 0,
      tenantId: currentTenant.id,
      selectedTenantId: 1,
      userId: user.referenceId,
      customerName: userDetail.customerName,
      customerMobileNumber: userDetail.customerMobileNumber,
      customerAddress: userDetail.customerAddress,
      preOrders: cartItems.map((item) => ({
        id: emptyGuid,
        name: item.name,
        price: Number(item.shopPrice) || 0,
        quantity: Number(item.quantity) || 1,
        portionName: 'Normal',
        markAsGift: false,
        orderDealProductList: [],
      })),
      states: [],
    };

    dispatch(savePreInvoiceRequest(onLoad));
    dispatch(clearCart());
    if (setShowBucketDetails) setShowBucketDetails(false);
  };

  return (
    <div
      className="card border-0 h-100 shadow-lg"
      style={{
        backgroundColor: contentBg,
        color: textColor,
        transition: '0.3s ease',
        borderRadius: '15px',
      }}
    >
      <div
        className="card-header bg-transparent py-3 border-bottom"
        style={{ borderColor: borderColor }}
      >
        <h5 className="mb-0 fw-bold" style={{ color: textColor }}>
          Cart Items List
        </h5>
      </div>

      <div className="card-body p-0 overflow-hidden">
        <PerfectScrollbar
          style={{ height: '55vh' }}
          options={{ wheelPropagation: true }}
        >
          <div className="p-3">
            {cartItems.length === 0 ? (
              <EmptyCart emptyButton={emptyButton} darkMode={isDark} />
            ) : (
              <div className="list-group list-group-flush">
                {cartItems.map((item) => (
                  <div
                    key={item.id}
                    className="card mb-3 border-0 shadow-sm"
                    style={{
                      backgroundColor: cardBg,
                      borderRadius: '12px',
                      border: `1px solid ${borderColor}`,
                    }}
                  >
                    <div className="card-body p-2">
                      <div className="d-flex align-items-center gap-3">
                        <div
                          className="rounded overflow-hidden"
                          style={{
                            width: '70px',
                            height: '70px',
                            flexShrink: 0,
                            backgroundColor: isDark
                              ? 'rgba(255,255,255,0.05)'
                              : '#f1f1f1',
                          }}
                        >
                          {item.image?.fileToken ? (
                            <img
                              src={`${getImagePath}${item.image.fileToken}`}
                              className="w-100 h-100 object-fit-cover"
                              alt={item.name}
                            />
                          ) : (
                            <div className="w-100 h-100 d-flex align-items-center justify-content-center small text-muted">
                              No Img
                            </div>
                          )}
                        </div>

                        <div className="flex-grow-1 overflow-hidden">
                          <div className="d-flex justify-content-between align-items-start mb-1">
                            <span
                              className="fw-bold small text-truncate"
                              style={{ color: textColor, maxWidth: '150px' }}
                            >
                              {item.name}
                            </span>
                            <span className="text-danger fw-bold small">
                              Rs{' '}
                              {(
                                item.shopPrice * item.quantity
                              ).toLocaleString()}
                            </span>
                          </div>

                          <div className="d-flex align-items-center justify-content-between mt-1">
                            <div
                              className="d-flex align-items-center rounded border"
                              style={{
                                backgroundColor: isDark
                                  ? 'rgba(255,255,255,0.05)'
                                  : '#f8f9fa',
                                borderColor: borderColor,
                              }}
                            >
                              <button
                                className="btn btn-sm p-1 text-danger rounded"
                                onClick={() =>
                                  dispatch(removeFromCart({ itemId: item.id }))
                                }
                              >
                                {item.quantity === 1 ? (
                                  <FaTrashAlt size={12} />
                                ) : (
                                  <FaMinus size={12} />
                                )}
                              </button>
                              <span
                                className="small fw-bold px-2"
                                style={{
                                  color: textColor,
                                }}
                              >
                                {item.quantity}
                              </span>
                              <button
                                className="btn btn-sm p-1 text-success rounded"
                                onClick={() =>
                                  dispatch(addToCart({ ...item, quantity: 1 }))
                                }
                              >
                                <FaPlus size={12} />
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        </PerfectScrollbar>
      </div>

      {cartItems.length > 0 && (
        <div
          className="card-footer border-0 p-3"
          style={{ backgroundColor: 'transparent' }}
        >
          <div
            className="mb-3 rounded-4 p-3 shadow-sm border"
            style={{
              backgroundColor: headerBg,
              borderColor: borderColor,
            }}
          >
            <div
              className="d-flex justify-content-between small mb-2"
              style={{ color: subTextColor }}
            >
              <span>Cart Subtotal:</span>
              <span className="fw-bold">Rs {totalPrice.toLocaleString()}</span>
            </div>

            <hr
              className="my-2"
              style={{ borderColor: borderColor, opacity: 0.2 }}
            />

            <div className="d-flex justify-content-between fw-bold fs-5 pt-1">
              <span style={{ color: textColor }}>Grand Total:</span>
              <span className="text-danger">
                Rs {finalTotal.toLocaleString()}
              </span>
            </div>
          </div>

          <button
            className="btn btn-danger w-100 py-3 fw-bold text-uppercase shadow rounded-pill"
            style={{
              fontSize: '14px',
              letterSpacing: '1px',
              transition: '0.3s',
            }}
            onClick={handlerForPlaceOrder}
          >
            Confirm & Place Order
          </button>
        </div>
      )}
    </div>
  );
};

export default Items_From_Cart;
